import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { combineLatest, of } from 'rxjs';
import { map, mergeMap, catchError, switchMap } from 'rxjs/operators';
import {
  GetDocumentId,
  GetDocumentIdSuccess,
  GetDocumentIdFailed,
} from './document-id.actions';
import { EnvService } from '../../services/env.service';
import { select, Store } from '@ngrx/store';
import { defaultCountry } from '../service-options';
import { isSdfCardFlow } from 'src/app/config/app-config';

@Injectable()
export class DocumentIdEffects {
  private documentUrl = `${this.envService.apiUrl}/v3/reference-data/identification-documents?`; // TODO:TIM does this need a v2???
  // documentUrl = `${this.envService.apiUrl}/v2/reference-data/identification-documents?`;

  constructor(
    private actions$: Actions,
    private http: HttpClient,
    private envService: EnvService,
    private store: Store
  ) {}

  public getDocumentId$ = createEffect(() =>
    this.actions$.pipe(
      ofType(GetDocumentId),
      switchMap((action) =>
        combineLatest([
          of(action.getDocumentIdRequest),
          this.store.pipe(select(defaultCountry)),
        ])
      ),
      mergeMap(([getDocumentIdRequest, country]) => {
        return this.http
          .get(
            `${this.documentUrl}userLanguage=${getDocumentIdRequest.userLanguage}&targetAudience=${getDocumentIdRequest.targetAudience}&transactingCountryCode=${country}`
          )
          .pipe(
            map((data: any) => {
              return GetDocumentIdSuccess({ getDocumentIdResponse: data });
            }),
            catchError((error) => of(GetDocumentIdFailed({ error })))
          );
      })
    )
  );
}
